
import {defineComponent} from 'vue'
import {ComponentEnum} from "@/config/config-types";
import LocationPicker from "@/components/picker/LocationPicker.vue";
import NumberPicker from "@/components/picker/NumberPicker.vue";
import DatePicker from "@/components/picker/DatePicker.vue";
import CategoryPicker from "@/components/picker/CategoryPicker.vue";
import StringPicker from "@/components/picker/StringPicker.vue";
import Button from "primevue/button";
import InfoButton from "@/components/legend/InfoButton.vue";

export default defineComponent({
  name: "SiteForm",
  components: {
    StringPicker, CategoryPicker, NumberPicker, LocationPicker, InfoButton,
    Button
  },
  data() {
    return {
      ComponentEnum
    }
  },
  props: {
    config: Object
  },
  methods: {
    select(payload: { key: string, value: any }) {
      this.$store.commit('setSiteValue', payload)
    }
  }
})
